module.exports = __webpack_public_path__ + "static/media/phone.cf67912d.png";